<template>
  <div class="header_box">
    <div class="logo_div">
      <a href="/show" class="logo_btn">
        <img src="../../assets/logo.png" />
        <img src="../../assets/logo_white.png" class="fixed_logo" />
      </a>
      <a href="javascript:void(0)" @click="searchld()"
        :style="ischecktype == 1 ? 'background: var(--fontHoverColor);' : ''" class="but" title="光亲和探针库">光亲和探针库</a>
      <a href="javascript:void(0)" @click="searchhz()"
        :style="ischecktype == 2 ? 'background: var(--fontHoverColor);' : ''" class="but" title="ABPP 探针库">ABPP 探针库</a>
        <div class="applydiv"><a href="https://www.leadartech.cn/pages/36.html" title="化学蛋白组学样品制备申请" target="_blank">化学蛋白组学样品制备申请</a></div>
    </div>


    <div class="right_info">
      <div class="search_box">
        <div class="search_form">
          <input type="text" placeholder="请输入搜索内容..." v-model="searchtext" @keyup.enter="searchData(2)" />
          <button type="button" @click="searchData(2)"><i class="iconfont icon-sousuo"></i></button>
        </div>
        <div class="hot_box">
          <label>Examples: </label>
          <div class="hot_btn">
            <a href="javascript:void(0)" @click="setinputtext('利福霉素钠')">利福霉素钠</a>
            <a href="javascript:void(0)" @click="setinputtext('39011-90-0')">39011-90-0</a>
            <a href="javascript:void(0)" @click="setinputtext('CC')">CC</a>
          </div>
          <label style="color:red;">骨架分子总数: {{ hxcount }}个</label>
        </div>
        
        <div class="hot_box" v-for="( item ) in  topshowtext " v-html='item+"</p>"' style="color: #fff;line-height: 22px;font-size: 14px;margin-right: 5px;font-weight: bold;">
        </div>
      </div>

      <div class="btn_box">
        <a href="javascript:void(0)" @click="searchSOpen()">结构式搜索</a>

        <a href="javascript:void(0)" @click="searchAll()">返回探针库</a>
      </div>
      <div class="iconfont_btn" v-if="!islogin">
        <router-link :to="{ path:'/login',query:{id:2}}"><i class="iconfont icon-yonghu2"></i></router-link>
        <!--<a href="javascript:void(0)"><i class="iconfont icon-shoucang7"></i></a>-->
      </div>
      <div class="iconfont_btn" v-if="islogin">
        <a href="javascript:void(0)"><i class="iconfont icon-yonghu2"></i><em>{{ username }}</em></a>
        <a href="javascript:void(0)" @click="modifyOpen()"><em>{{ $t("button.change_password") }}</em></a>
        <a href="javascript:void(0)" class="login_out" @click="loginout()">{{ $t("button.quit") }}</a>
      </div>
    </div>


    <div class="pop_bg" v-show="popBgShow" @click="closeAll()"></div>
    <div class="pop_search" v-show="popSearchShow">
      <div class="header_info">
        <div class="title">高级搜索</div>
        <a href="javascript:void(0)" class="close_btn" @click="searchClose()">×</a>
      </div>
      <div class="advanced_search">
        <div class="search_item" v-for="(v, index) in searchItem" :key="index">
          <label :for="v">
            NOT<input type="checkbox" :value="index" v-model="checkOption[index]" />
          </label>
          <select v-model="selected[index]">
            <option v-for="option in options" :value="option.value">
              {{ option.text }}
            </option>
          </select>
          <input type="text" placeholder="请输入文字搜索" class="text" v-model="searchKeyword[index]" />
        </div>
      </div>
      <div class="footer_btn">
        <a href="javascript:void(0)" @click="searchClose()">关闭</a>
        <a href="javascript:void(0)" @click="addRow">添加</a>
        <a href="javascript:void(0)" @click="searchData(1)">搜索</a>
      </div>
    </div>
    <div class="pop_search" v-show="popSearchStrShow" style="width: 1008px;">

    </div>
    <div class="pop_search" v-show="popSearchStrShow" style="width: 1008px;">
      <div class="header_info">
        <div class="title">结构式搜索</div>
        <a href="javascript:void(0)" class="close_btn" @click="searchClose()">×</a>
      </div>
      <div class="panel" style="width: 1006px;">
        <div title="" class="panel-body panel-body-noheader panel-body-noborder dialog-content"
          style="width: 1006px; height: 504px;">
          <div id="kjsmketcher_dlgid">
            <div style="width:700px;float:left;">
              <iframe ref="iframea" src="/static/ketcher/ketcher.html" width="100%" height="500" style="border:none;"
                scrolling="no" id="kjsmketcher" name="kjsmketcher">
              </iframe>
            </div>
            <div
              style="text-align:center;float:right;line-height:25px;width:280px;height:470px;margin-top:5px;border-left:solid 1px #ccc;padding-left:10px;">
              <div style="margin:5px 0 5px 0;font-size:16px;">结构式图片搜索</div>
              <div id="SSimgArea"
                style="display: inline-block;width:230px;height:160px;line-height:13;text-align:center;border:solid 1px #eee;">
                Ctrl+V 粘贴图片</div>
              <div style="margin:5px;"><span id="SSbtnUpFile">
                  <input type="hidden" class="atcatalog" value="Z000"><input type="hidden" class="atobjid"
                    value="clipboardData"><input type="hidden" class="attmpobjid" value="">
                </span>&nbsp;&nbsp;<input type="button" id="SSbtnClean" value="清除图片"
                  @click="clearStr()">&nbsp;&nbsp;<input type="button" id="SSbtnConvert" value="转图片为结构式"
                  @click="changeStr()" :disabled="disabledstatus"></div>
              <div style="margin:25px 0 15px 0;font-size:16px;">结构式搜索选项</div>
              <div style="text-align:left;font-size:14px;margin-left:10px;">
                <div style="line-height:25px;" v-for="(item, key) in radiooptions" :key="key">
                  <input type="radio" name="searchType" :value="item.value" v-model="radiocheck"><label>{{ item.text
                  }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer_btn">
        <a href="javascript:void(0)" @click="searchstrbut()">结构式搜索</a>
      </div>
    </div>
    <div class="pop_apply_box" v-show="passwordPopShow">
      <div class="header_info">
        <div class="title">修改密码</div>
        <a href="javascript:void(0)" class="close_btn" @click="closeAll()">×</a>
      </div>
      <form :model="modifyForm" :rules="modifyrules">
        <dl class="formcolumn-item ">
          <dt class="formcolumn-item-tit">密码：</dt>
          <dd class="formcolumn-item-ct">
            <input type="password" placeholder="输入密码" name="oldpassword" v-model="modifyForm.oldpassword">
          </dd>
        </dl>
        <dl class="formcolumn-item ">
          <dt class="formcolumn-item-tit">新密码：</dt>
          <dd class="formcolumn-item-ct">
            <input type="password" placeholder="输入新密码，密码最少6位，包括至少1个大写字母，1个小写字母，1个数字，1个特殊字符" name="newpassword" v-model="modifyForm.newpassword">
          </dd>
        </dl>
        <dl class="formcolumn-item ">
          <dt class="formcolumn-item-tit">确认新密码：</dt>
          <dd class="formcolumn-item-ct">
            <input type="password" placeholder="再次输入新密码" name="newpasswordvalidate"
              v-model="modifyForm.newpasswordvalidate">
          </dd>
        </dl>
        <div class="footer_btn">
          <input type="button" id="ORDERPOST" value="修改" @click="modifyconfirm()">
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import api from './../../axios/api.js';
import md5 from './../../assets/js/md5.min.js'
export default {
  data() {
    return {
      searchtext: "",
      selected: ["ALL"],
      searchKeyword: [""],
      options: [
        { text: 'ALL', value: "ALL" },
        { text: 'LDDB id', value: 'LDDBid' },
        { text: 'Target Proteins', value: 'ProteinId' },
        { text: 'species', value: 'Species' },
        { text: 'Protein Description', value: 'ProteinDescription' },
        { text: 'Gene Name', value: 'GeneNames' },
        { text: 'Probe ID', value: 'ProbeId' },
        { text: 'Probe type', value: 'ProbeType' },
        { text: 'Labeled Sites', value: 'SitesList' },
        { text: '浓度', value: 'Density' },
        { text: '竞争比值（P/PC）', value: 'CompetitiveRatio' },
        { text: '竞争配体', value: 'LigandId' },
        { text: '数据来源', value: 'Source' }
      ],
      searchItem: ["advancedValue1"],
      count: 1,
      popSearchShow: false,
      popBgShow: false,
      checkOption: [false],
      islogin: false,
      username: "",
      popStrShow: false,
      passwordPopShow: false,
      popSearchStrShow: false,
      modifyForm: {
        oldpassword: "",
        newpassword: "",
        newpasswordvalidate: ""
      },
      modifyrules: {
        oldpassword: [{ required: true, message: "请输入密码", trigger: "blur" }],
        newpassword: [{ required: true, message: "请输入新密码", trigger: "blur" }],
        newpasswordvalidate: [{ required: true, message: "请再次输入新密码", trigger: "blur" }],
      },
      radiooptions: [
        { text: '精确搜索', value: "exact" },
        { text: '子结构搜索', value: 'sub' },
        { text: '60%相似度结构搜索', value: 'similarity-0.6' },
        { text: '80%相似度结构搜索', value: 'similarity-0.8' },
        { text: '90%相似度结构搜索', value: 'similarity-0.9' }
      ],
      ketcher: null,
      mltext: '',
      radiocheck: "sub",
      loading: false,
      disabledstatus: false,
      hxcount: 0,
      ischecktype: false,
      topshowtext:[],
      searchcontentparam:{}
    }

  },
  created() {
    this.isLogined();
    var searchCon1 = window.sessionStorage.getItem('searchCon');
    //当首页，并且有查询条件
    if (searchCon1&&this.$route.path == "/show") {
      searchCon1 = JSON.parse(window.sessionStorage.getItem('searchCon'));
      this.radiocheck = searchCon1.radiocheck;
      this.radiooptions = searchCon1.radiooptions;
      this.searchItem = searchCon1.searchItem;
      this.searchKeyword = searchCon1.searchKeyword;
      this.searchtext = searchCon1.searchtext;
      this.selected = searchCon1.selected;

      if (searchCon1.butclick < 3) {
        this.searchData(searchCon1.butclick);
        return;
      }
      this.searchThreeData(searchCon1.smile);
    }
    /*
    $('#kjsmketcher').bind('load',
      function () {
        if (!ketcher) {
          ketcher = $('#kjsmketcher')[0].contentWindow.ketcher;
        }
      });*/
    //头部内容查询
    this.getcompanyinfo();
    //头部金额查询
    this.getCount();
    //检验登录用户
    this.checkUser();
  },
  mounted: function () {
    var that = this;
    document.addEventListener('paste', function (event) {
      // 获取文件
      var file = event.clipboardData.files;
      if (window.FileReader && file.length > 0) {
        var reader = new FileReader();
        reader.readAsDataURL(file[0]);
        //监听文件读取结束后事件
        reader.onloadend = function (e) {
          that.mltext = "1";
          var base64String = e.target.result;
          let urllist = '/action/egiohnwpnwarmiivu/getmol';
          var psbase = base64String.replace("data:image/png;base64,", '');
          var param = {
            "ErpId": "B5FECF1D-B5E8-4AB0-84AB-2E1B13814501",
            "ImgData": psbase
          };
          var ssimg = $("img", $("#SSimgArea", $("#ssimg")));
          if (ssimg.length == 0) {
            $("#SSimgArea").html("<img id='ssimg' style='max-width:220px;max-height:160px;' />");
            ssimg = $("#ssimg");
          }
          ssimg.attr('src', base64String);
          api.getTableData(urllist, JSON.stringify(param)).then(res => {
            if (res) {
              that.mltext = res.data.replaceAll("\\r\\n", "\r\n");
            }
          });
        };
      }
    });
  },
  methods: {
    async checkUser(){
      var that=this;
      let urllist = '/user/checklogin';
      await api.getData(urllist).then(res => {
      });
    },
    loginout() {
      this.islogin = false;
      this.username = "";
      localStorage.removeItem("authtoken");
      localStorage.removeItem("isLogined");
      localStorage.removeItem("needLogin");
      localStorage.removeItem("username");
      location.href = "/show";
    },
    modifyconfirm() {
      let oldpassword = this.modifyForm.oldpassword;
      let newpassword = this.modifyForm.newpassword;
      let newpasswordvalidate =this.modifyForm.newpasswordvalidate;
      if (!oldpassword) {
        this.showMessage("账号不能为空！");
        return;
      } else if (!newpassword) {
        this.showMessage("新密码不能为空！");
        return;
      } else if (!newpasswordvalidate) {
        this.showMessage("确认新密码不能为空！");
        return;
      } else {
        ////密码正则，最少6位，包括至少1个大写字母，1个小写字母，1个数字，1个特殊字符
        var pwdPattern = /^.*(?=.{6,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*? ]).*$/;
        if (newpassword != newpassword) {
          this.showMessage("两次输入的密码需要一致");
          return;
        }
        if (!pwdPattern.test(newpassword)) {
          this.showMessage("您的密码格式有误");
          return;
        }
        oldpassword = md5.md5(this.modifyForm.oldpassword, 32);
        newpassword = md5.md5(this.modifyForm.newpassword, 32);
        newpasswordvalidate = md5.md5(this.modifyForm.newpasswordvalidate, 32);
        let urllist = '/action/users/modifypassword';
        let username = localStorage.getItem("username");
        api.getTableData(urllist, JSON.stringify({ "username": username, oldpassword: oldpassword, newpassword: newpassword, newpasswordvalidate: newpasswordvalidate })).then(res => {
          if (res.result == 1) {
            window["authtoken"] = "";
            localStorage.removeItem("authtoken");
            localStorage.removeItem("isLogined");
            localStorage.removeItem("needLogin");
            localStorage.removeItem("username");
            location.href = "/login?id=2";
          }
        });
      }
    },
    isLogined() {
      this.islogin = localStorage.getItem("isLogined");
      this.username = localStorage.getItem("username");
    },
    async getcompanyinfo(){
      var that=this;
      let urllist = '/action/efmoeanjdmfpygvzv/getop';
      await api.getTableData(urllist).then(res => {
        if (res.data&&res.data.rows) {
          if(res.data.rows[0]['content']){
            that.topshowtext=res.data.rows[0]['content'].split('</p>')
          }

        }
      });
    },
    searchld() {
      var that = this;
      that.ischecktype = 1;
      var searchparam = {};
      searchparam['seatype'] = 4;
      searchparam['content'] = { "$and": [{ "probe_type": "光亲和探针" }] };
      that.searchThreeData(searchparam);
      that.getCount();
    },
    searchhz() {
      var that = this;
      that.ischecktype = 2;
      var searchparam = {};
      searchparam['seatype'] = 4;
      searchparam['content'] = { "$and": [{ "probe_type": "ABPP探针" }] };
      that.searchThreeData(searchparam);
      this.$emit("changeshowmse", '近期上线，敬请期待');
      that.getCount();
    },
    searchAll() {
      location.reload();
    },
    async getCount() {
      let that = this;
      that.hxcount = 0;
      let urllist = '/action/ewfeahhhiobbuyfzm/getcount';
      await api.getTableData(urllist, JSON.stringify(that.searchcontentparam)).then(res => {
        if (res.data) {
          that.hxcount = res.data._count;
        }
      })
    },
    setinputtext(val) {
      this.searchtext = val;
    },
    changeStr() {
      var that = this;
      that.disabledstatus = false;
      if (!that.mltext) {
        that.showInfo("请上传图片");
        return;
      }
      if (that.mltext == '""') {
        that.showInfo("未能成功解析出图片中的结构式，请换张图片重试！");
        return;
      }
      if (that.mltext == "1") {
        that.disabledstatus = true;
        setTimeout(function () { that.changeStr() }, 3000)
        return;
      }
      that.disabledstatus = false;
      that.$refs.iframea.contentWindow.ketcher.setMolecule(that.mltext);
    },
    clearStr() {
      var that = this;
      that.mltext = "";
      that.loading = false;
      $("#ssimg").remove();
    },
    searchstrbut() {
      window.sessionStorage.removeItem("searchCon");
      var that = this;
      if (!this.ketcher) {
        this.ketcher = this.$refs.iframea.contentWindow.ketcher;
      }
      if (!this.ketcher) {
        this.showInfo('结构式搜索正在初始化,请稍后...');
        return false;
      }
      if (that.loading) {
        this.showInfo('正在查询，请勿重复点击查询按钮！');
        return false;
      }
      var smile = this.ketcher.getSmiles();
      if (!smile) {
        this.showInfo('请先画结构式后再点击搜索按钮！');
        return false;
      }
      var typeall = that.radiocheck.split('-');
      var json = {
        "searchType": typeall[0],
        "smile": smile,
        "othermust": {
          "catalogno.keyword": "母核SMILES"
        },
        "page": 1,
        "psize": 1000
      };
      if (typeall.length > 1) {
        json.similarity = typeall[1];
      }
      var urllist = "/action/ewfeahhhiobbuyfzm/searchstr";
      that.loading = true;
      api.getTableData(urllist, JSON.stringify(json)).then(res => {
        var searchparam = {};
        searchparam['seatype'] = 3;
        if (res.data) {
          var param = res.data;
          searchparam['content'] = param;
        }
        if (this.$route.path != "/show") {
          var searchCon = {};
          searchCon.radiocheck = this.radiocheck;
          searchCon.radiooptions = this.radiooptions;
          searchCon.searchItem = this.searchItem;
          searchCon.searchKeyword = this.searchKeyword;
          searchCon.searchtext = this.searchtext;
          searchCon.selected = this.selected;
          searchCon.smile = searchparam;
          searchCon.butclick = 3;
          var savepstr = JSON.stringify(searchCon);
          window.sessionStorage.setItem("searchCon", savepstr);
          this.$router.replace({
            path: '/show'
          });
          return;
        }
        if (res.data) {
          that.searchThreeData(searchparam);
        } else {
          this.showMessage("异常");
        }
        that.loading = false;
      });
      that.searchClose();
    },
    searchThreeData(searchparam) {
      this.searchcontentparam=searchparam;
      this.$emit("setsearchdateshow", JSON.stringify(searchparam));
      this.getCount();
    },
    async filechange(file, fileList) {
      let af = file.target.files;
      var ssimg = $("img", $("#SSimgArea", $("#ssimg")));
      if (ssimg.length == 0) {
        $("#SSimgArea").html("<img id='ssimg' style='max-width:220px;max-height:160px;' />");
        ssimg = $("#ssimg");
      }
      ssimg.attr('src', af[0].FilePath);
      ssimg.attr('data-id', af[0].Id);
      //文件base64string获取
      if (window.FileReader) {
        var reader = new FileReader();
        reader.readAsDataURL(af[0]);
        //监听文件读取结束后事件
        reader.onloadend = function (e) {
          var base64String = e.target.result;
          let urllist = 'http://ocrapi.erp.kuujiasoft.com/Ocr/ConvertMol';
          var param = {
            "ErpId": "B5FECF1D-B5E8-4AB0-84AB-2E1B13814501",
            "ImgData": base64String
          };
          api.getTableData(urllist, JSON.stringify(param)).then(res => {
            if (res.data) {
              var filename = res.data.name;
              var url = "https://work.kuujia.web960.com:8776/openapi/utils/downexcel?file=" + filename;
              window.open(url);
            }
          });
        };
      }
    },
    uploadimgfile() {
      this.$refs.uploadRef.dispatchEvent(new MouseEvent('click'))
    },

    modifyOpen() {
      this.popBgShow = true;
      this.passwordPopShow = true;
    },
    searchSOpen() {
      this.popBgShow = true;
      this.popSearchStrShow = true;
    },
    searchstrOpen() {
      this.popBgShow = true;
      this.popStrShow = true;
      show_what();
    },
    searchOpen() {
      this.popBgShow = true;
      this.popSearchShow = true;
    },
    closeAll() {
      this.popBgShow = false;
      this.popSearchShow = false;
      this.popStrShow = false;
      this.passwordPopShow = false;
    },
    searchClose() {
      this.popBgShow = false;
      this.popSearchShow = false;
      this.popStrShow = false;
      this.popSearchStrShow = false;
    },
    addRow() {
      this.count++;
      var newItem = "advancedValue" + this.count;
      this.searchItem.push(newItem);
      this.selected.push("ALL");
      this.checkOption.push(false);
      this.searchKeyword.push("");
    },
    searchData(val) {
      var that = this;
      var param = {};
      var pararr = [];
      window.sessionStorage.removeItem("searchCon");
      if (this.$route.path != "/show") {
        var searchCon = {};
        searchCon.radiocheck = this.radiocheck;
        searchCon.radiooptions = this.radiooptions;
        searchCon.searchItem = this.searchItem;
        searchCon.searchKeyword = this.searchKeyword;
        searchCon.searchtext = this.searchtext;
        searchCon.selected = this.selected;
        searchCon.butclick = val;
        var savepstr = JSON.stringify(searchCon);
        window.sessionStorage.setItem("searchCon", savepstr);
        this.$router.replace({
          path: '/show'
        });
        return;
      }
      if (val == 1) {
        that.checkOption.forEach(function (val, index) {
          if (that.searchKeyword[index]) {
            pararr.push({ "key": that.selected[index], "val": that.searchKeyword[index], "notcheck": val });
          }
        });
      } else {
        pararr.push({ "key": "ALL", "val": that.searchtext, "notcheck": false });
      }
      if (pararr.length > 0) {
        param['allsearch'] = pararr;
      }
      this.$emit("setsearchdateshow", JSON.stringify(param));
      this.searchClose();
      this.searchcontentparam=param;
      this.getCount();
    },

    showMessage(val) {
      toastr.error(val, "错误", {
        closeButton: true,
        progressBar: true,
        newestOnTop: true
      });
    },
    showInfo(val) {
      toastr.info(val, "提醒", {
        closeButton: true,
        progressBar: true,
        newestOnTop: true,
        positionClass: "toast-top-center"
      });
    }
  }
}
</script>
<style>
.pop_search .footer_btn a:nth-child(1) {
  border-color: var(--bgHoverColor);
  background: var(--bgHoverColor);
  color: #fff;
}

.header_box .logo_div .logo_btn {
  height: 60px;
  width: 390px;
  position: relative;
  display: flex;
}

.header_box .logo_div .logo_btn img {
  max-height: 100%;
  max-width: 100%;
  transition: all 0.2s linear 0s;
}

.header_box .logo_div .logo_btn .fixed_logo {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
}

.header_fixed_box .logo_div {
  display: none;
}

.logo_div .but {
  width: 110px;
  height: 42px;
  border-radius: 5px;
  background: var(--bgColor);
  font-size: 14px;
  color: #fff;
  line-height: 42px;
  text-align: center;
  display: inline-block;
  margin-top: 14px;
  margin-left: 10px;
}

.applydiv {
    margin-top: 18px;
    margin-left: 10px;
    font-size: 16px;
}

.applydiv a {
  font-weight: bold;
    background: var(--fontHoverColor);
    width: 230px;
    height: 42px;
    border-radius: 20px;
    font-size: 14px;
    color: #fff;
    line-height: 42px;
    text-align: center;
    display: inline-block;
}
</style>





// WEBPACK FOOTER //
// src/views/header/IndexShow.vue